store.checkout = {};
store.checkout.init = function() {
	var $mainBox = $('body.checkout #store.box');
	var $stepperContent = $mainBox.find('.stepperContent');
	if ($stepperContent.hasClass('payment')) {
		store.checkout.payment.init($mainBox);
	}
};
store.checkout.address = {};
store.checkout.address.initSelect = function() {
	$('.addressSelect').change(function(){
		var $this = $(this);
		var rel = $this.attr('rel');
		var addressId = $this.val();
		var divSel = '.'+rel + 'AddressWrap .addressWrap';
		$(divSel).load($this.parents('form').attr('data-load')+"/" + addressId);
	});
};
store.checkout.payment = {
	init: function($mainBox) {
		$mainBox.find('.ddSelect').each(function() {
			var $dd = $(this);
			var selectedValue = $dd.find('option[selected=selected]').val();
			$dd.ddSelect({
				ddSelectChange: function() {
					var $this = $(this);
					var $opts = $this.find('option');
					var $selected;
					if (selectedValue) {
						$selected = $opts.filter('[value=' + selectedValue + ']');
					}
					if (!$selected || $selected.length < 1) {
						$selected = $opts.filter(':last');
					}
					$selected.prop('selected', true);
				}
			});
			$dd.trigger('change');
		});
	}
};

if (jQuery) {
	jQuery('document').ready(store.checkout.init);
}
